import { ChevronUp } from 'lucide-react';
import { Button } from '@/ui/components/ui/button';
import { cn } from '@/ui/lib/utils';

interface VoteButtonProps {
	votes: number;
	isVoted: boolean;
	isPopping: boolean;
	onVote: () => void;
}

export function VoteButton({
	votes,
	isVoted,
	isPopping,
	onVote,
}: VoteButtonProps) {
	return (
		<Button
			type='button'
			onClick={onVote}
			style={{ transformOrigin: 'center center' }}
			className={cn(
				'flex flex-col h-auto min-w-12 py-2 rounded-lg gap-0 border-none',
				isVoted
					? 'bg-primary hover:bg-primary text-primary-foreground'
					: 'bg-background text-foreground shadow-ionos-btn-inner hover:bg-secondary',
				isPopping && 'animate-vote-pop',
			)}
		>
			<ChevronUp
				size={14}
				strokeWidth={2.5}
				className={cn(
					isVoted
						? 'text-primary-foreground'
						: 'text-muted-foreground',
				)}
			/>
			<span
				className={cn(
					'text-[15px] font-bold leading-[1.3] inline-block',
					isVoted ? 'text-primary-foreground' : 'text-foreground',
					isPopping && 'animate-count-bump',
				)}
			>
				{votes}
			</span>
		</Button>
	);
}
